module.exports = __webpack_public_path__ + "img/l-sonede.17dccf31.png";